/**
 * Recipient journey, Part 6: Stage 3, you and the sender. Trust earned.
 *
 * Small pure pieces the room uses:
 *  - when the Mystic asks her birthday (R6.3): after her own first reading has
 *    landed and been rated, or after she thanked, whichever comes first, once;
 *  - the words of the turns that follow (R6.5 to R6.11);
 *  - the Altar's first promotion to the bar opening to the Mirror (R6.12).
 */

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
  'October', 'November', 'December']

/** "March 3" from "1993-03-03" (the year is hers to know, R6.4's line leaves it out). */
export function monthDay (iso = '') {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '')
  if (!m) return ''
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}`
}

/** "a" or "an" before a sign ("an Aries", "a Pisces"). */
export function article (word = '') {
  return /^[AEIOU]/i.test(word) ? 'an' : 'a'
}

/** R6.4: "Chris says you're a Pisces, born March 3." */
export function suggestedLine ({ from_name: from = '', sun = '', birthdate = '' } = {}) {
  const who = (from || '').trim() || 'Someone'
  const sign = sun ? `${article(sun)} ${sun}, ` : ''
  return `${who} says you're ${sign}born ${monthDay(birthdate)}.`
}

/** R6.5: the Mystic asks for the date only, by her name. */
export function birthdayAsk (name = '') {
  const n = (name || '').trim()
  return n ? `${n}, when is your birthday?` : 'When is your birthday?'
}

/** R6.8: what a date shows, and what a birth time adds, said plainly. */
export const DATE_SEES = 'From a birth date I can see your Sun, Venus and Mars, and your Moon roughly. ' +
  'A birth time and place add your rising sign and the exact Moon.'
export const CLOSER_LOOK = 'With your birth time I can see more.'
export function theirTimeLine (name = '') {
  const n = (name || '').trim()
  return n ? `With ${n}'s birth time I could see more.` : 'With their birth time I could see more.'
}

// R6.10's "Your sign and the two of you are kept here." is gone (gift room
// redo, 2026-10-29): the Mirror keeps them, and the room's last step links to it.

/** R6.11: said once, the first time the sender's message arrives. */
export function wroteBackLine (from = '') {
  return `${(from || '').trim() || 'They'} wrote back.`
}

/** A line as segments, one word of it a link. */
export function linkSegments (text = '', word = '') {
  const at = word ? text.lastIndexOf(word) : -1
  if (at === -1) return [{ text }]
  return [
    ...(at ? [{ text: text.slice(0, at) }] : []),
    { text: word, link: true },
    ...(at + word.length < text.length ? [{ text: text.slice(at + word.length) }] : []),
  ]
}

/**
 * R6.3: the moment the birthday is asked. `trigger` is 'stars' (in the gift
 * room, they tapped "What do <sender>'s stars say about us?": round 2 finish,
 * DESIGN-2 §39) or 'thanked' (kept for callers outside the room; once, never
 * again after `asked`). The stars chip is her asking, so it always opens
 * Stage 3, asked before or not (StageThree skips the ask when her birthday is
 * known; gift bug walk 2026-10-25 #8). Never on its own after her own reading
 * ('own_rated' is gone: the round-2 rule, bug walk #11).
 */
export function shouldAskBirthday ({ trigger = '', asked = false, signedIn = false } = {}) {
  if (!signedIn) return false
  if (trigger === 'stars') return true
  return !asked && trigger === 'thanked'
}

// What this device remembers, per package: asked (R6.3, once) and said
// (R6.11, once). Where the Altar lands is the server's now (nav.altar_first_tab).
const KEYS = { asked: 'ma_s3_asked_', wrote: 'ma_s3_wrote_' }

function read (key) {
  try { return localStorage.getItem(key) } catch (e) { return null }
}
function write (key, value = '1') {
  try { localStorage.setItem(key, value) } catch (e) { /* a nicety; the server is the record */ }
}

export function wasAsked (inv) { return !!(inv && read(KEYS.asked + inv)) }
export function markAsked (inv) { if (inv) write(KEYS.asked + inv) }
export function wroteBackSaid (inv) { return !!(inv && read(KEYS.wrote + inv)) }
export function markWroteBack (inv) { if (inv) write(KEYS.wrote + inv) }
